<template>
	<div id="app">
		<transition :name="transitionName">
			<router-view class="body-wrap" />
		</transition>
	</div>
</template>

<script>
	import "@/assets/css/animate/animate.min.css";
	import Vue from 'vue'
	import {
		getLanguageConfig,
	} from '@/common/api/public.js'
	export default {
		name: 'app',
		data() {
			return {
				transitionName: 'slide-right'
			}
		},
		watch: {
			$route() {
				let isBack = this.$router.isBack
				if (isBack) {
					this.transitionName = 'slide-right'
				} else {
					this.transitionName = 'slide-left'
				}
				this.$router.isBack = false
			}
		},
		async created() {
			// const {
			// 	data
			// } = await getLanguageConfig()
			// if (data.switch) {
			// 	Vue.prototype.$language = data[data.switch]
			// } else {
			// 	Vue.prototype.$language = data.zh
			// }
			// document.title = this.$language.systemTitle.name
			// let getCreate = function(url) {
			// 	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			// 	link.type = 'image/x-icon';
			// 	link.rel = 'shortcut icon';
			// 	link.href = url
			// 	document.getElementsByTagName('head')[0].appendChild(link);
			// }
			// if (this.$language.systemIco.name) {
			// 	getCreate(this.$language.systemIco.name)
			// }
		},

	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 16px;
		color: #333;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}



	/* Webkit 浏览器 */
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background-color: #D4D4D4;
		border-radius: 5px;
	}

	/* Firefox 浏览器 */
	scrollbar-color: #4979ff #f1f1f1;
	scrollbar-width: thin;

	html,
	body,
	p {
		padding: 0 !important;
		margin: 0 !important;
	}

	p {
		margin-bottom: 0.625rem;
	}

	.research-experience p,
	.form p {
		margin: 15px 0;
	}

	/* .ql-align-center {
		text-align: center;
	} */

	/* 公共样式 */
	.flex {
		display: flex;
		flex-direction: row;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.col-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-wrap: nowrap;
	}

	.row-center {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.flex-sb {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.flex-sa {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.flex-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.flex-cb {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	/* 自定义弹出层样式 */
	.el-dialog__header {
		background-color: #4389DF !important;
		padding: 1.125rem 1.25rem !important;
	}

	.el-dialog {
		border-radius: 0 !important;
		overflow: hidden !important;
	}

	.dialog-head {
		margin: 0;
		color: white;
	}

	.w-e-full-screen-container {
		z-index: 9;
	}

	.el-popover.el-popper .el-textarea__inner {
		font-size: 16px;
	}

	.el-tooltip__popper {
		max-width: 50vw;
		max-height: 50vh;
		overflow-y: auto;
	}

	.el-tooltip__popper.is-dark {
		font-size: 16px;
	}

	.tag-blue {
		background: #E9F4FF;
		border-radius: 2px;
		border: 1px solid #A0CFFF;
		padding: 6px 10px;
		color: #3196FC;
		display: inline-block;
		font-size: 14px;
	}

	.tag-red {
		background: #FFF3F3;
		border-radius: 2px;
		border: 1px solid #FFBFBF;
		padding: 6px 10px;
		color: #FF7474;
		display: inline-block;
		font-size: 14px;
	}

	.tag-green {
		background: #E8FAEB;
		border-radius: 2px;
		border: 1px solid #BCF1C5;
		padding: 6px 10px;
		color: #00C016;
		display: inline-block;
		font-size: 14px;
	}

	.tag-silver {
		background: #f8f8f8;
		border-radius: 2px;
		border: 1px solid #909399;
		padding: 6px 10px;
		color: #909399;
		display: inline-block;
		font-size: 14px;
	}

	.table-custom {
		border: 1px solid #E0E3E5;
	}

	.table-custom .el-table th.el-table__cell {
		background-color: #DBDBDB;
	}

	.table-custom .el-table th.el-table__cell .cell {
		font-size: 14px;
		color: #000000;
		font-weight: bold;
	}

	.table-custom .blue {
		color: #007EFF;
		cursor: pointer;
	}

	.table-custom .blue:hover {
		text-decoration: underline;
	}

	.table-custom .blue-2 {
		color: #4DA3F3;
		cursor: pointer;
	}

	.table-custom .blue-2:hover {
		text-decoration: underline;
	}

	.table-custom .blue-3 {
		color: #00bae2;
		cursor: pointer;
	}

	.table-custom .blue-3:hover {
		text-decoration: underline;
	}

	.table-custom .line {
		width: 1px;
		height: 14px;
		background: #c1c1c1;
		margin: 0 10px;
	}

	.table-custom .red {
		color: #ff7474;
		cursor: pointer;
	}

	.table-custom .red:hover {
		text-decoration: underline;
	}

	.table-custom .blue-em {
		color: blue;
		cursor: pointer;
	}

	.table-custom .blue-em:hover {
		text-decoration: underline;
	}

	.table-custom .purple {
		color: #a68bfc;
		cursor: pointer;
	}

	.table-custom .purple:hover {
		text-decoration: underline;
	}

	.el-dialog__header {
		background-color: #F2F4F6 !important;
		color: #000;
		font-size: 18px;
		font-weight: 600;
	}

	.el-dialog__body,
	.el-dialog__footer {
		padding: 0;
	}

	.el-button.el-button--primary.cus {
		background-color: #007EFF;
	}

	.animated.an1 {
		animation-delay: .1s
	}

	.animated.an2 {
		animation-delay: .2s
	}

	.animated.an3 {
		animation-delay: .3s
	}

	.animated.an4 {
		animation-delay: .4s
	}

	.animated.an5 {
		animation-delay: .5s
	}

	@media screen and (max-width: 922px) {

		/* 隐藏垂直滚动条 */
		::-webkit-scrollbar {
			width: 0 !important;
		}

		/* 隐藏水平滚动条 */
		::-webkit-scrollbar {
			height: 0 !important;
		}

		scrollbar-width: auto;
	}

	html {
		overflow-x: hidden !important;
	}
</style>